import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {
  AccordionContentComponent,
  AccordionSection,
} from "../../common/accordion-content/accordion-content.component";

@Component({
  selector: "app-validation-warning-modal",
  standalone: true,
  imports: [AccordionContentComponent, CommonModule],
  templateUrl: "./validation-warning-modal.component.html",
  styleUrl: "./validation-warning-modal.component.scss",
})
export class ValidationWarningModalComponent {
  activeModal = inject(NgbActiveModal);
  errorMsgItems: string[] = [];
  errorMsgIntro: string = '';
  isOrderedList: boolean = false;

  @Input() set configs(value: {
    title: string;
    subTitle: string;
    requiredAction: string;
    errorMsg: string;
    tip: string;
    data: AccordionSection[];
    buttonText: string;
  }) {
    this._configs = value;
    this.parseErrorMsg(value.errorMsg);
  }

  get configs() {
    return this._configs;
  }

  private _configs: {
    title: string;
    subTitle: string;
    requiredAction: string;
    errorMsg: string;
    tip: string;
    data: AccordionSection[];
    buttonText: string;
  } = {
    title: "",
    subTitle: "",
    requiredAction: "",
    errorMsg: "",
    tip: "",
    data: [],
    buttonText: "",
  };

  private parseErrorMsg(errorMsg: string) {
    if (!errorMsg) {
      this.isOrderedList = false;
      this.errorMsgItems = [];
      this.errorMsgIntro = '';
      return;
    }

    // Check if the message contains numbered items like (1), (2), etc.
    const firstNumberMatch = errorMsg.match(/\(\d+\)/);
    
    if (firstNumberMatch && firstNumberMatch.index !== undefined) {
      // Extract intro text before the first number
      const introText = errorMsg.substring(0, firstNumberMatch.index).trim();
      
      // Extract the numbered portion
      const numberedText = errorMsg.substring(firstNumberMatch.index);
      
      // Split by numbered patterns like (1), (2), etc.
      const items = numberedText
        .split(/(?=\(\d+\))/)
        .map(item => item.trim())
        .filter(item => item.length > 0)
        .map(item => item.replace(/^\(\d+\)\s*/, ''));
      
      if (items.length > 0) {
        this.isOrderedList = true;
        this.errorMsgIntro = introText;
        this.errorMsgItems = items;
        return;
      }
    }

    // If no numbered pattern found, treat as regular text
    this.isOrderedList = false;
    this.errorMsgItems = [];
    this.errorMsgIntro = '';
  }
}
